<script setup>

import {ErrorMessage, Field, Form} from 'vee-validate'
import {reactive, ref} from 'vue'
import axios from 'axios'
import useGlobalStore from '../../store/globalStore'
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors, enquirySubmitDataLayer, sendFBLeadData } = useFormSubmit()
const props = defineProps({
  postUrl: {
    type: String,
    default: '',
  },
})

const schema = {
  first_name: 'required',
  last_name: 'required',
  email: 'required|email',
  phone_number: 'required|phoneNumber',
}

const confirmation = reactive({show: false, message: '', class: ''})
const globalStore = useGlobalStore()
let isSubmitting = ref(false)

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('eventRegisterForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post(props.postUrl, formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg
      enquirySubmitDataLayer(form);
      sendFBLeadData(formData.get('subject'));
      let currentUrl = window.location.href;
      currentUrl = currentUrl.replace('#enquiry-submitted', '');
      history.pushState(null, null, `${currentUrl}#enquiry-submitted`);
      const modalTitle = globalStore.modal.title;

      globalStore.setModal(
        {
          name: 'showSuccessMessageModal',
          title: `Thank you, we have sent your request to <br>${modalTitle} to provide additional information about their upcoming ${formData.get('event_type')}`,
        }
      )
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}
</script>

<template>
  <Form
    class="modal-form w-100"
    :validation-schema="schema"
    v-slot="{ errors }"
    @submit="onSubmit"
    id="eventRegisterForm"
  >
    <slot name="token"></slot>
    <div class="form-group form-group--input">
      <label for="name" class="sr-only">Name</label>
      <Field
        id="first_name"
        name="first_name"
        placeholder="First name *"
        class="form-control"
        :class="{'is-danger': errors['first_name'] }"
        tabindex="1"
        autofocus
        autocomplete="off"
      />
      <ErrorMessage name="first_name" class="is-danger" as="span" >
        The name field is required
      </ErrorMessage>
    </div>
    <div class="form-group form-group--input">
      <label for="last_name" class="sr-only">Last name</label>
      <Field
        name="last_name"
        class="form-control"
        placeholder="Last name *"
        :class="{'is-danger': errors['last_name'] }"
        id="last_name"
      />
      <ErrorMessage name="last_name" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="email" class="sr-only">Email</label>
      <Field
        tabindex="3"
        id="email"
        name="email"
        placeholder="Email *"
        class="form-control"
        :class="{'is-danger': errors['email'] }"
      />
      <ErrorMessage name="email" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="phone_number" class="sr-only">Phone</label>
      <Field
        tabindex="4"
        id="phone_number"
        name="phone_number"
        placeholder="Phone *"
        class="form-control"
        :class="{'is-danger': errors['phone_number'] }"
      />
      <ErrorMessage name="phone_number" class="is-danger" />
    </div>
    <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
    <Field type="hidden" name="captcha_action" value="event_register_form" />
    <slot name="hiddenfields"></slot>
    <input type="hidden" name="event_id" :value="globalStore.modal.id">
    <input type="hidden" name="event_type" id="event-type" >
    <button type="submit" class="button button--green button--h-45 fs-15 submit" tabindex="5">
      Learn more
    </button>
    <slot name="googlerecaptchatext"></slot>
  </Form>
</template>
